function applyTransitionDelay(megamenu_container) {
  const megaMenuItems = megamenu_container;
  const megaChildItems =
    megamenu_container.querySelectorAll(".--megamenu-card");

  megaChildItems.forEach((item, index) => {
    const delay = (index / megaChildItems.length) * 0.5;
    item.style.transitionDelay = `${delay}s`;
  });

  // megaMenuItems.forEach((item, index) => {
  //   const delay = 0.5 + (index / megaMenuItems.length) * 0.5;
  //   item.style.transitionDelay = `${delay}s`;
  // });
}

function removeTransitionDelay(megamenu_container) {
  const megaMenuItems = megamenu_container;
  const megaChildItems =
    megamenu_container.querySelectorAll(".--megamenu-card");

  // megaMenuItems.forEach((item) => (item.style.transitionDelay = ""));
  megaChildItems.forEach((item) => (item.style.transitionDelay = ""));
}

document.addEventListener("DOMContentLoaded", () => {
  let megamenu_triggers = document.querySelectorAll(
    ".--nav-item.item__mega-link"
  );
  let mobile_megamenu_triggers = document.querySelectorAll(
    ".--mobile-nav-wrapper .plus"
  );
  let mobile_close_megamenu_triggers = document.querySelectorAll(
    ".--mobile-nav-wrapper .minus"
  );
  let megamenu_containers = document.querySelectorAll(".--mega-menu-container");

  // Add event listeners for each trigger
  megamenu_triggers.forEach((megamenu_trigger) => {
    let closeTimeout;

    megamenu_trigger.addEventListener("mouseenter", () => {
      // Clear any previous close timeout when entering the trigger
      if (closeTimeout) {
        clearTimeout(closeTimeout);
      }

      // Open the corresponding mega menu
      megamenu_containers.forEach((megamenu_container) => {
        if (
          megamenu_trigger.dataset.title === megamenu_container.dataset.title
        ) {
          megamenu_container.classList.add("active-mega-menu");
          applyTransitionDelay(megamenu_container);
        }
      });
    });

    megamenu_trigger.addEventListener("mouseleave", () => {
      // Delay closing the mega menu when mouse leaves the trigger
      closeTimeout = setTimeout(() => {
        megamenu_containers.forEach((megamenu_container) => {
          if (
            megamenu_trigger.dataset.title === megamenu_container.dataset.title
          ) {
            megamenu_container.classList.remove("active-mega-menu");
            removeTransitionDelay(megamenu_container);
          }
        });
      }, 300); // Adjust delay as necessary
    });
  });
  // Add event listeners for each trigger mobile
  mobile_megamenu_triggers.forEach((megamenu_trigger) => {
    let closeTimeout;

    megamenu_trigger.addEventListener("click", () => {
      let parent = megamenu_trigger.closest('.--mobile-mega-menu-controls');
      parent.classList.add("active-control");
      // Clear any previous close timeout when entering the trigger
      if (closeTimeout) {
        clearTimeout(closeTimeout);
      }

      // Open the corresponding mega menu
      megamenu_containers.forEach((megamenu_container) => {
        if (
          megamenu_trigger.dataset.title === megamenu_container.dataset.title
        ) {
          megamenu_container.classList.add("active-mega-menu");
          applyTransitionDelay(megamenu_container);
        }
      });
    });
  });
  // Add event listeners for each trigger in mobile to close megamenu
  mobile_close_megamenu_triggers.forEach((megamenu_trigger) => {
    let closeTimeout;

    megamenu_trigger.addEventListener("click", () => {
      let parent = megamenu_trigger.closest('.--mobile-mega-menu-controls');
      parent.classList.remove("active-control");
      closeTimeout = setTimeout(() => {
        megamenu_containers.forEach((megamenu_container) => {
          if (
            megamenu_trigger.dataset.title === megamenu_container.dataset.title
          ) {
            megamenu_container.classList.remove("active-mega-menu");
            removeTransitionDelay(megamenu_container);
          }
        });
      }, 300); // Adjust delay as necessary
    });
  });
});



// Define the sticky header function on the window object
window.stickyHeader = function () {
  // const header = document.querySelector('#shopify-section-maze-recovery-header');
  const header = document.querySelector('.section-container--maze-recovery-header');
  if(!header){
    return;
  }

// Correct way - Get the first section
let firstSection = document.querySelectorAll('.content-for-layout section')[0];
if (firstSection && firstSection.classList.contains('--banner-section')) {
  console.log("Start with Banner");
  header.classList.add('--enable-transparent-header');
}
// --banner-section
  // Add scroll event listener
  window.addEventListener('scroll', () => {
    if (window.scrollY > header.offsetTop) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  });
};

// Call the function when DOM content is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.stickyHeader();
});